import { combineReducers } from 'redux';

import { userWatchersUniqueIdsReducer } from './userWatchersUniqueIds';
import { userWatchersMapReducer } from './userWatchersMap';
import { watchersDecisionsMapReducer } from './watchersDecisionsMap';
import { watchersKeysReducer } from './watchersKeys';
import { watchersQueriesMapReducer } from './watchersQueriesMap';

export const reducersRaw = {
  userWatchers: combineReducers({
    uniquesIds: userWatchersUniqueIdsReducer,
    map: userWatchersMapReducer,
  }),
  watchers: combineReducers({
    keys: watchersKeysReducer,
    numberOfNewDecisionsMap: watchersDecisionsMapReducer,
    queriesMap: watchersQueriesMapReducer,
  }),
};
